<ng-container *transloco="let t">
  <div id="maintenance-page" class="min-h-screen bg-ld-neutral-50 flex items-center justify-center p-4">
    <div class="max-w-md w-full bg-white rounded-2xl shadow-card p-8 text-center">
      <div
        id="maintenance-icon"
        class="size-20 rounded-full bg-ld-primary-50 flex items-center justify-center mx-auto mb-6"
      >
        <mat-icon class="text-ld-primary text-5xl! w-12! h-12!">construction</mat-icon>
      </div>

      <h1 id="maintenance-title" class="text-2xl font-dm font-bold text-ld-neutral mb-4">
        {{ t('authMaintenanceTitle') }}
      </h1>

      <p id="maintenance-description" class="font-dm text-ld-neutral-600 mb-6 leading-relaxed">
        {{ message() || t('authMaintenanceDefaultMessage') }}
      </p>

      @if (expectedEndTime()) {
        <div id="maintenance-end-time" class="p-4 bg-ld-neutral-50 rounded-xl mb-6">
          <p class="font-dm text-sm text-ld-neutral-500 mb-1">{{ t('authMaintenanceExpectedBack') }}</p>
          <p class="font-dm font-semibold text-ld-neutral">{{ getFormattedEndTime() }}</p>
        </div>
      }

      <div id="maintenance-contact" class="p-4 bg-blue-50 border border-blue-200 rounded-xl mb-6 text-left">
        <div class="flex items-start gap-3">
          <mat-icon class="text-blue-600 shrink-0 mt-0.5">support_agent</mat-icon>
          <div>
            <h3 class="font-dm font-medium text-blue-800 text-sm mb-1">{{ t('authMaintenanceNeedAssistance') }}</h3>
            <p class="font-dm text-xs text-blue-700">
              {{ t('authMaintenanceContactSupport') }}
              <strong>1-888-337-6888</strong>
              .
            </p>
          </div>
        </div>
      </div>

      <button
        id="maintenance-retry-btn"
        type="button"
        class="w-full px-6 py-3 text-base font-dm font-bold text-white bg-ld-primary rounded-xl hover:bg-ld-primary-600 transition-colors cursor-pointer"
        (click)="onRetry()"
      >
        <mat-icon class="mr-2 align-middle text-xl!">refresh</mat-icon>
        {{ t('authMaintenanceCheckAgain') }}
      </button>
    </div>
  </div>
</ng-container>
